const boats = {
    en: {
        "boats.title": "Boats",
        "boats.id": "ID",
        "boats.name": "Name",
        "boats.identificationCode": "Identification Code",
        "boats.estDepartureDate": "Est. Departure Date",
        "boats.estArrivalDate": "Est. Arrival Date",
        "boats.arrivalDate": "Arrival Date",
        "boats.status": "Status",

        "boats.onWay": "On Way",

        "boats.removeTitle": "Remove boat",
        "boats.removeConfirm": "Do you want to remove boat?",
        "boats.addTitle": "Add New Boat",
        "boats.editTitle": "Modify boat data",

        "boats.identifier": "Identifier",
        "boats.departureDate": "Departure Date",

        "boats.phName": "Enter boat name",
        "boats.phIdentifier": "Enter boat identifier",
    },
    ru: {
        "boats.title": "Суда",
        "boats.id": "ID",
        "boats.name": "Название",
        "boats.identificationCode": "Идентификационный код",
        "boats.estDepartureDate": "Ожид. дата отправления",
        "boats.estArrivalDate": "Ожид. дата прибытия",
        "boats.arrivalDate": "Дата прибытия",
        "boats.status": "Статус",

        "boats.onWay": "В пути",

        "boats.removeTitle": "Удалить судно",
        "boats.removeConfirm": "Вы действительно хотите удалить судно?",
        "boats.addTitle": "Добавить судно",
        "boats.editTitle": "Изменить данные судна",

        "boats.identifier": "Идентификатор",
        "boats.departureDate": "Дата отправления",

        "boats.phName": "Введите название судна",
        "boats.phIdentifier": "Введите идентификатор судна",
    },
    geo: {
        "boats.title": "გემები",
        "boats.id": "ID",
        "boats.name": "სახელი",
        "boats.identificationCode": "საიდენტიფიკაციო კოდი",
        "boats.estDepartureDate": "სავარაუდო გასვლის თარიღი",
        "boats.estArrivalDate": "სავარაუდო ჩამოსვლის თარიღი",
        "boats.arrivalDate": "ჩამოსვლის თარიღი",
        "boats.status": "სტატუსი",

        "boats.onWay": "გზაში",

        "boats.removeTitle": "გემის წაშლა",
        "boats.removeConfirm": "გსურთ გემის წაშლა?",
        "boats.addTitle": "ახალი გემის დამატება",
        "boats.editTitle": "გემის მონაცემების რედაქტირება",

        "boats.identifier": "იდენტიფიკატორი",
        "boats.departureDate": "გასვლის თარიღი",

        "boats.phName": "შეიყვანეთ გემის სახელი",
        "boats.phIdentifier": "შეიყვანეთ გემის იდენტიფიკატორი",
    },
};

export default boats;
